import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



const cardData = {
  keyword: "Swift Dzire On Rent In Pune",

"headingDescription": "SRS Cab Service offers Swift Dzire On Rent in Pune, providing a stylish, comfortable, and reliable travel solution for individuals, families, and corporate clients. Our well-maintained Swift Dzire cars, professional drivers, and timely service ensure a smooth and hassle-free journey across Pune. Ideal for airport transfers, city tours, business trips, and weekend getaways, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support to make every trip safe and enjoyable.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a key landmark in Pune. Travelers renting a Swift Dzire from SRS Cab Service often visit this site to admire Maratha architecture and capture the city’s cultural essence."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent historical site connected to India’s freedom struggle. Visitors using Swift Dzire from SRS Cab Service often explore its serene gardens and informative museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is known for its panoramic hill views and trekking opportunities. Travelers renting a Swift Dzire from SRS Cab Service frequently plan a visit for sightseeing and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Visitors using Swift Dzire from SRS Cab Service often stop here to experience spiritual serenity and local traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Travelers renting a Swift Dzire from SRS Cab Service enjoy its historic charm and peaceful environment."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts. Visitors using Swift Dzire from SRS Cab Service explore Pune’s rich cultural and artistic heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers renting a Swift Dzire from SRS Cab Service often climb the hill for sightseeing and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful destination surrounded by water and hills. Travelers using Swift Dzire from SRS Cab Service often include this spot in their itinerary for relaxation and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped garden ideal for calm walks. Visitors renting a Swift Dzire from SRS Cab Service enjoy its lush greenery and serene ambiance."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Travelers using Swift Dzire from SRS Cab Service often explore this landmark to understand Pune’s rich heritage."
  }
],



services: [
{
name: "Swift Dzire Per Km Rate Pune",
description: "Swift Dzire per km rate Pune provides transparent pricing for local and outstation travel. Customers can check per km charges before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Choose Dzire cab services with clear per km pricing."
},
{
name: "Swift Dzire Rent Per Km Rate Per Day",
description: "Swift Dzire rent per km rate per day offers flexible pricing for daily travel. Customers can book cars with per km billing options. Affordable pricing ensures cost-effective journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Travel easily with daily Dzire rental plans."
},
{
name: "Swift Dzire Per Km Rate in Pune",
description: "Swift Dzire per km rate in Pune provides detailed fare information for travelers. Customers can compare pricing before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose Dzire services with transparent pricing."
},
{
name: "Swift Dzire Per Km Rate Pimpri Chinchwad",
description: "Swift Dzire per km rate Pimpri Chinchwad offers clear pricing for local and outstation travel. Customers can check rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with Dzire cab services."
},
{
name: "Swift Dzire Tour Service Cost",
description: "Swift Dzire tour service cost provides estimated pricing for travel packages. Customers can plan trips with affordable pricing options. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Choose Dzire tour services for budget travel."
},
{
name: "Pune to Mahabaleshwar Swift Dzire Tour",
description: "Pune to Mahabaleshwar Swift Dzire tour offers comfortable travel for hill station trips. Customers can enjoy scenic journeys. Professional drivers ensure safe ghat road travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar with Dzire."
},
{
name: "Pune to Shirdi Swift Dzire Tour",
description: "Pune to Shirdi Swift Dzire tour provides convenient travel for temple visits. Customers can book cars for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Shirdi with Dzire services."
},
{
name: "Pune Airport to Shirdi Tour Packages",
description: "Pune airport to Shirdi tour packages offer direct travel from airport to temple destination. Customers can book packages for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily from airport to Shirdi."
},
{
name: "Pune to Nashik Swift Dzire on Rent",
description: "Pune to Nashik Swift Dzire on rent offers comfortable travel for religious and leisure trips. Customers can book vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Nashik with Dzire."
},
{
name: "Pune to Lonavala Swift Dzire on Rent",
description: "Pune to Lonavala Swift Dzire on rent provides convenient travel for short trips. Customers can book vehicles for outings and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Lonavala with Dzire."
},
{
name: "Pune to Ashtavinayak Darshan Swift Dzire on Rent",
description: "Pune to Ashtavinayak darshan Swift Dzire on rent offers comfortable travel for temple tours. Customers can book cars for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Dzire darshan services."
},
{
name: "Pune to Panchgani Swift Dzire on Rent",
description: "Pune to Panchgani Swift Dzire on rent offers comfortable travel for hill station visits. Customers can enjoy scenic routes. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Panchgani with Dzire."
},
{
name: "Pune to Lavasa Swift Dzire on Rent",
description: "Pune to Lavasa Swift Dzire on rent provides convenient travel for weekend trips. Customers can book vehicles for leisure travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Lavasa with Dzire."
},
{
name: "Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent",
description: "Pune to 5 Jyotirlinga darshan Swift Dzire on rent offers spiritual travel for devotees. Customers can visit multiple temples comfortably. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Dzire darshan tours."
},
{
name: "Pune Darshan Swift Dzire on Rent",
description: "Pune darshan Swift Dzire on rent provides convenient city tour options. Customers can explore local attractions easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Pune darshan Dzire services."
},
{
name: "Swift Dzire Rent Near Me",
description: "Swift Dzire rent near me offers quick booking options for nearby travel. Customers can find cabs easily for immediate needs. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book Dzire rentals near you easily."
},
{
name: "Swift Dzire Online Booking",
description: "Swift Dzire online booking provides easy and fast reservation options. Customers can book cars digitally with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Dzire online easily."
},
{
name: "Swift Dzire Rent Pune",
description: "Swift Dzire rent Pune offers affordable travel solutions for local and outstation trips. Customers can book vehicles for flexible travel plans. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Dzire rentals in Pune."
}
],

tableData: [
["Swift Dzire Per Km Rate Pune","Swift Dzire Rent Per Km Rate Per Day"],
["Swift Dzire Per Km Rate in Pune","Swift Dzire Per Km Rate Pimpri Chinchwad"],
["Swift Dzire Tour Service Cost","Pune to Mahabaleshwar Swift Dzire Tour"],
["Pune to Shirdi Swift Dzire Tour","Pune Airport to Shirdi Tour Packages"],
["Pune to Nashik Swift Dzire on Rent","Pune to Lonavala Swift Dzire on Rent"],
["Pune to Ashtavinayak Darshan Swift Dzire on Rent","Pune to Panchgani Swift Dzire on Rent"],
["Pune to Lavasa Swift Dzire on Rent","Pune to 5 Jyotirlinga Darshan Swift Dzire on Rent"],
["Pune Darshan Swift Dzire on Rent","Swift Dzire Rent Near Me"],
["Swift Dzire Online Booking","Swift Dzire Rent Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Affordable Sedan Travel Option",
    WhyChoosedescription: "SRS Cab Service offers Swift Dzire on rent in Pune as one of the most budget-friendly sedan options, perfect for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Best Per KM Pricing in Pune",
    WhyChoosedescription: "Swift Dzire rental in Pune typically starts from ₹11 to ₹15 per km depending on service type, making it a cost-effective choice for both local and outstation travel. :contentReference[oaicite:0]{index=0}"
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Swift Dzire is widely used for Pune to Mumbai, Shirdi, Nashik, Lonavala, and airport travel, offering smooth performance and excellent mileage for long journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Swift Dzire bookings in Pune, ensuring easy availability for early morning, late-night, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable 4+1 Seating Capacity",
    WhyChoosedescription: "Swift Dzire comes with comfortable 4+1 seating, making it ideal for small families, couples, and business travel with adequate luggage space."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "We provide trained and experienced drivers who are familiar with Pune roads and highways, ensuring safe, smooth, and reliable travel."
  },
  {
    WhyChooseheading: "Clean & AC Well-Maintained Cars",
    WhyChoosedescription: "All Swift Dzire cabs are air-conditioned, regularly serviced, and cleaned to provide a hygienic and comfortable ride experience."
  },
  {
    WhyChooseheading: "Trusted Swift Dzire Rental Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Swift Dzire on rent in Pune due to affordable pricing, punctual service, and consistent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide Swift Dzire on rent in Pune?", answer: "Yes, SRS Cab Service offers Swift Dzire rental in Pune for local, airport, and outstation travel." },
  { question: "What is the price of Swift Dzire per km in Pune?", answer: "Swift Dzire rental typically starts from ₹11 to ₹15 per km depending on the trip and service type." },
  { question: "Is Swift Dzire suitable for outstation trips?", answer: "Yes, Swift Dzire is ideal for outstation travel like Mumbai, Shirdi, Nashik, and Lonavala." },
  { question: "How many passengers can travel in Swift Dzire?", answer: "Swift Dzire has a seating capacity of 4 passengers plus driver." },
  { question: "Is Swift Dzire available for airport transfer?", answer: "Yes, Swift Dzire is widely used for Pune Airport and Mumbai Airport transfers." },
  { question: "Is Swift Dzire cab available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "Are Swift Dzire cars air-conditioned?", answer: "Yes, all Swift Dzire vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book Swift Dzire online?", answer: "Yes, you can easily book Swift Dzire on rent in Pune online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip Swift Dzire cab services." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Deshmukh",
    feedback:
      "Booked Swift Dzire from SRS Cab Service for Mumbai trip. Very smooth ride and affordable pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Patil",
    feedback:
      "Best Swift Dzire rental in Pune. Clean car, professional driver, and comfortable journey.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Swift Dzire on rent in Pune with affordable per km rates for local and outstation travel. Book Swift Dzire for Pune to Mahabaleshwar, Shirdi, Nashik, Lonavala, Ashtavinayak Darshan, Panchgani, Lavasa, and Jyotirlinga tours. Enjoy comfortable rides, online booking, and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Swift Dzire On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Swift Dzire on rent in Pune with SRS Cab. Affordable per km rates for local and outstation trips to Mahabaleshwar, Shirdi, Nashik, Lonavala, Ashtavinayak, Panchgani, Lavasa and more. 24x7 online booking available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;